'use client';

import { useEffect } from 'react';

import { Loader } from '@polyai/ui/components/atoms/Loader';

import { useParagonUrls } from 'hooks/useParagon';

const PARAM_WHITELIST = [
  'code',
  'state',
  'connection_id',
  'provider',
  'project_id',
];

const ParagonOAuthRedirect = () => {
  const { oauthBaseUrl } = useParagonUrls();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const filteredParams = new URLSearchParams();
    PARAM_WHITELIST.forEach(key => {
      const value = params.get(key);
      if (value !== null) {
        filteredParams.set(key, value);
      }
    });

    window.location.href = `${oauthBaseUrl}/oauth?${filteredParams.toString()}`;
  }, [oauthBaseUrl]);

  return <Loader inProjectPage={false} fullScreen logo />;
};

export default ParagonOAuthRedirect;
